module.exports = __webpack_public_path__ + "img/i-sold-this.e589fa5d.png";